import { Box } from '@qga/roo-ui/components';

import type { FC } from 'react';

interface ErrorShape {
  message?: string;
}

export interface FieldErrorProps {
  error?: ErrorShape;
}

export const FieldError: FC<FieldErrorProps> = ({ error, ...rest }) => {
  return error ? (
    <Box
      bg="ui.errorBackground"
      color="greys.steel"
      fontSize={['sm', 'base']}
      p={2}
      data-testid="input-error"
      {...rest}
    >
      {error.message}
    </Box>
  ) : null;
};
